import { Component, ViewEncapsulation } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

import { AppService } from './app.service';
import { CastService } from './cast/services/cast-service';
import { ApFeedViewStateRecord, FtpFeedViewStateRecord } from './common/data-models/records/ap-feed-viewstate-record';
import { AssignmentViewStateRecord } from './common/data-models/records/assignment-viewstate-record';
import { DraftSearchViewStateRecord } from './common/data-models/records/draft-search-viewstate-record';
import { DraftViewStateRecord } from './common/data-models/records/draft-viewstate-record';
import { MultipleFeedViewStateRecord } from './common/data-models/records/mutiple-feed-viewstate-record';
import { PublicationViewStateRecord } from './common/data-models/records/publication-viewstate-record';
import { RecordFactory } from './common/data-models/records/record-factory';
import { RSSFeedViewStateRecord } from './common/data-models/records/rss-feed-viewstate-record';
import { RundownListViewStateRecord } from './common/data-models/records/rundown-list-viewstate-record';
import { SearchViewStateRecord } from './common/data-models/records/search-viewstate-record';
import { SingleItemViewStateRecord } from './common/data-models/records/single-item-viewstate-record';
import { StoryViewStateRecord } from './common/data-models/records/story-viewstate-record';
import { TopicViewStateRecord } from './common/data-models/records/topic-viewstate-record';
import { TwitterFeedViewStateRecord } from './common/data-models/records/twitter-feed-viewstate-record';
import { ViewStateRecord } from './common/data-models/records/viewstate-record';
import { WireSearchViewStateRecord } from './common/data-models/records/wire-search-viewstate-record';
import { WireViewStateRecord } from './common/data-models/records/wire-viewstate-record';
import { ViewStateTypes } from './common/enums/viewstate-types';
import { NomWebServicesJson } from './common/services/nom-web-services-json';
import { DiscoverSearchService } from './discover/services/discover-search-service';
import { DiscoverService } from './discover/services/discover-service';
import { PlaybookService } from './playbook/services/playbook-service';

@Component({
    selector: 'st-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: {
        class: 'st-app-component',
    },
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
    private registerRecords() {
        // RecordFactory.registerRecord(ObjectTypesEnum.NGGRID, CollectionRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.RUNDOWN, RundownRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.STORYBOARD, CollectionRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.EXPORTFORMAT, ExportFormatRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.USER, UserRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.PSTVIEWSTATE, ViewStateRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.WIRE, WireRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.CONTACT, ContactRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.PUBLICATION_CHANNEL, PublicationChannelRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.PUBLICATION, PublicationRecord);
        // RecordFactory.registerRecord(ObjectTypesEnum.UNASSIGNED, Record);
        // RecordFactory.registerRecord(ObjectTypesEnum.PUBLICATIONLIST, PublicationListRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SYSTEM, ViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.TOPIC, TopicViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SCRIPT, StoryViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.ASSIGNMENT, AssignmentViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SEARCH, SearchViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SINGLEITEM, SingleItemViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.DRAFT, DraftViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.DRAFTSEARCH, DraftSearchViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.WIRE, WireViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.WIRESEARCH, WireSearchViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.ROLIST, RundownListViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.PUBLICATION, PublicationViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.MULTIPLEFEED, MultipleFeedViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.RSSFEED, RSSFeedViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.TWITTERFEED, TwitterFeedViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.WIREFEED, ApFeedViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.APFEED, ApFeedViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.FTPFEED, FtpFeedViewStateRecord);
    }

    constructor(
        private router: Router,
        private appService: AppService,
        public playbookService: PlaybookService,
        public castService: CastService,
        public discoverService: DiscoverService,
        public discoverSearchService: DiscoverSearchService,
        private nomWebServicesJson: NomWebServicesJson
    ) {
        this.registerRecords();

        this.router.events
            .pipe(
                filter((e: any) => e instanceof RoutesRecognized),
                pairwise()
            )
            .subscribe((e: any) => {
                localStorage.setItem('prevUrl', e[1].urlAfterRedirects);
                this.appService.previousUrl = e[1].urlAfterRedirects;
            });

        const registerServiceWorker = () => {
            navigator.serviceWorker
                .register('./img-service-service.js')
                .then(() => {
                    return navigator.serviceWorker.ready;
                })
                .then(reg => {
                    this.nomWebServicesJson.imgServiceWorker = reg.active;
                    this.nomWebServicesJson.imgServiceWorker.postMessage({ authorization: this.nomWebServicesJson.token });
                })
                .catch(error => {
                    console.log('Error : ', error);
                });
        };
        if (!navigator?.serviceWorker?.controller) {
            navigator.serviceWorker.getRegistrations().then(registrations => {
                Promise.all(registrations.map(r => r.unregister())).then(() => {
                    registerServiceWorker();
                });
            });
        } else {
            registerServiceWorker();
        }
    }
}
